import { PropsWithChildren, ReactElement } from 'react';

import { BrowserRouter } from 'react-router-dom';

const Providers = ({ children }: PropsWithChildren): ReactElement => {
  return <BrowserRouter>{children}</BrowserRouter>;
};

export default Providers;
